module.exports = __webpack_public_path__ + "static/img/active3.3a9c52bf.png";